import { call, put, takeLatest } from 'redux-saga/effects';
import { convertName } from '../utils/orders';
import { ADD_ORDER, ADD_ORDER_FAILS, ADD_ORDER_SUCCESS } from './../actions/addOrder';
import { ADD_ORDER_FROM_SHIPMENT, ADD_ORDER_FROM_SHIPMENT_FAILS, ADD_ORDER_FROM_SHIPMENT_SUCCESS } from './../actions/editOrder';
import hanldeException from './../services/handleException';
import history from './../services/history';
import { addOrder } from './../utils/orders';

export function* addOrderSaga() {
    yield takeLatest(ADD_ORDER, addOrderHandle)
}

function* addOrderHandle(action) {
    try {
        let data = action.payload
        if (typeof data.ConsigneeYomiganaName === 'string' && !data.ConsigneeYomiganaName.trim()) {
            const convertToYomigana = yield call(convertName, { OriginalString: data.ConsigneeName })
            if (convertToYomigana.data.data) {
                data.ConsigneeYomiganaName = convertToYomigana.data.data.ConvertedString
            }
        }

        const response = yield call(addOrder, data)
        if (response.data.code === 10001) {
            yield put({ type: ADD_ORDER_SUCCESS, payload: response })
            history.push('/orders')
        } else {
            yield put({ type: ADD_ORDER_FAILS, payload: response })
            hanldeException(response)
        }
    } catch (error) {
        yield put({ type: ADD_ORDER_FAILS, payload: error })
        hanldeException(error)
    }
}

export function* addOrderFromShipmentSaga() {
    yield takeLatest(ADD_ORDER_FROM_SHIPMENT, addOrderFromShipmentHandle)
}

function* addOrderFromShipmentHandle(action) {
    try {
        const response = yield call(addOrder, action.payload)

        if (response.data.code === 10001) {
            response.status_list = action.payload.status_list
            yield put({ type: ADD_ORDER_FROM_SHIPMENT_SUCCESS, payload: response })
            history.goBack()
        } else {
            yield put({ type: ADD_ORDER_FROM_SHIPMENT_FAILS, payload: response })
            hanldeException(response)
        }
    } catch (error) {
        yield put({ type: ADD_ORDER_FROM_SHIPMENT_FAILS, payload: error })
        hanldeException(error)
    }
}




// WEBPACK FOOTER //
// ./src/sagas/addOrderSaga.js